import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { AvailablePaymentType } from "@/interfaces/payment-type.interface";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<AvailablePaymentType[] | null>;

const useGetAvailablePaymentTypes = (enabled = true): Return => {
  const { data = null, isValidating: isLoading, error } = useSWR<AvailablePaymentType[], Error>(
    enabled ? [SWR_KEYS.getAvailablePaymentTypes] : null,
    () => t2payService.getAvailablePaymentTypes(),
    { revalidateOnFocus: false, dedupingInterval: 5000 }
  );

  return { data, isLoading, error };
};

export default useGetAvailablePaymentTypes;
